// Module
var code = `<div class="product-tile">

    <div class="product-tile-image-wrapper">

        <div data-bind="visible: instanceCount > 1, attr: {title: instanceCount + ' varianten beschikbaar'}" class="product-tile-instance-count">
            <img class="product-tile-instance-icon" src="/assets/icons/icon-variants-white-16.svg"><span data-bind="text: instanceCount"></span>
        </div>

        <button data-bind="click: addToFavorites" class="product-tile-add-to-favourites" type="button">
            <!--<span data-bind="hidden: !isFavoriteLoading()" class="spinner-border spinner-border-sm text-dark"></span>-->
            <img data-bind="visible: !isFavorite() && !isFavoriteLoading()" src="/assets/icons/icon-star-outline-24.svg" title="Voeg toe aan favorieten" />
            <img data-bind="visible: isFavorite() && !isFavoriteLoading()" src="/assets/icons/icon-star-blue-24.svg" title="Verwijder uit favorieten" />
        </button>

        <a class="product-tile-image" data-bind="attr: {href: slug}">
            <img data-bind="attr: {src: thumbnail, alt: title}" loading="lazy" />
        </a>

        <div data-bind="visible: standards.length > 0, foreach: {data: standards, as: 'standard', noChildContext: false}" class="product-tile-standards-wrapper">
            <img data-bind="attr: {src: standard.icon, alt: standard.name, title: standard.name + ' - ' + \$parent.displayStandards(standard)}" class="product-tile-standard-icon" />
        </div>

    </div>

    <div class="product-tile-info-wrapper">

        <div class="product-tile-info">
            <div data-bind="visible: brand !== null, text: brand" class="product-tile-brand"></div>
            <a data-bind="visible: categoryText != null, text: categoryText, attr: {href: categorySlug}" class="product-tile-category"></a>
            <a class="product-tile-title" data-bind="attr: {href: slug}" href="#"><h3 data-bind="text: title"></h3></a>
            <div data-bind="text: \`Artikelnr. \${firstSku}\`" href="#" class="product-tile-data"></div>
            <div data-bind="visible: properties !== null, foreach: {data: properties, as:'property', noChildContext: true}">
                <div data-bind="text: \`\${property.key}: \${property.value}\`" class="product-tile-data"></div>
            </div>
            <!-- ko if: price !== null && (price.price > 0 || canCheckoutFreeItems) -->
            <div class="product-tile-stock in-stock">
                <span data-bind="text: (stock > 0 ? 'Op voorraad' : 'Levertijd op aanvraag')"></span>
            </div>
            <!-- /ko -->
            <!-- ko ifnot: price !== null && (price.price > 0 || canCheckoutFreeItems) -->
            <div class="product-tile-stock">
                <span>Niet leverbaar</span>
            </div>
            <!-- /ko -->
        </div>

        <!-- ko if: price !== null && (price.price > 0 || canCheckoutFreeItems) -->
        <div class="product-tile-add-to-cart-container">
            <div class="product-tile-price-container">
                <div class="product-tile-price">
                    <span data-bind="text: price.displayPrice" class="price"></span>
                    <span data-bind="visible: price.qtyModifier > 1" class="unit">
                        /
                        <span data-bind="text: price.qtyModifier"></span>
                        <span data-bind="text: price.uomDescription"></span>
                    </span>
                </div>
                <!--<div class="product-tile-tax">
                    <span data-bind="text: price.displayVatText"></span>
                </div>-->
            </div>
            
            
            <!--<div class="product-tile-attribute-selector">
                <label>Maat</label>
                <select>
                    <option>One</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                </select>
            </div>-->

            <!--ko if: price !== null-->
            <div class="product-tile-quantity-wrapper">
                <form method="POST" class="quantity-wrapper" action="#">
                    <input data-bind="click: decreaseQty, attr: {disabled: quantity() <= 1 ? true : null}" type="button" class="quantity-button decrease" title="Aantal verlagen" />
                    <input data-bind="value: quantity, numeric: item.quantity" type="text" inputmode="numeric" pattern="[0-9]*" spellcheck="false" class="quantity-input" />
                    <input data-bind="click: increaseQty" type="button" class="quantity-button increase" title="Aantal verhogen" />
                </form>
                <button data-bind="click: addToCart" class="primary-button medium add-to-cart-button" type="button" title="Toevoegen aan winkelwagen">
                    <img data-bind="hidden: isAddToCartLoading() || isAddedToCart()" src="/assets/icons/icon-addtocart-white-32.svg" />
                    <img data-bind="hidden: !isAddToCartLoading() || isAddedToCart()" src="/assets/icons/icon-loadingcart-white-32.svg" />
                    <img data-bind="hidden: !isAddedToCart()" src="/assets/icons/icon-checkcart-white-32.svg" class="icon-checkcart" />
                </button>
            </div>
            <!-- /ko -->

        </div>
        <!-- /ko -->

    </div>

</div>

`;
// Exports
module.exports = code;